import React from 'react'
import NavBar from '../../../features/navbar/Navbar'
import Footer from '../../../features/common/Footer'
import ProductList from '../../../features/product/components/ProductList'
import WomenOversized from '../../../features/productmen/components/womenOversized'



const OversizedWomen = () => {
  return (
    <div>
    <WomenOversized></WomenOversized>
    </div>
  )
}

export default OversizedWomen
